import { render } from "./HelpComp.vue?vue&type=template&id=9526cfc0&scoped=true"
import script from "./HelpComp.vue?vue&type=script&lang=js"
export * from "./HelpComp.vue?vue&type=script&lang=js"

import "./HelpComp.vue?vue&type=style&index=0&id=9526cfc0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Korisnik\\Desktop\\3. Semestar Mag\\VUI\\DiplomaInsight\\DiplomaInsight\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9526cfc0"]])

export default __exports__